import { Cookie as CookieNames, FeatureFlag } from '@ps/web-core-enums';
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import Cookies from 'universal-cookie';

import StarsButton from '@swf/components/StarsButton/StarsButton';
import type { ModalContextValue } from '@swf/components/StarsModal/Context';
import { ModalContext } from '@swf/components/StarsModal/Context';
import Translation from '@swf/components/Translation/Translation';
import flags from '@swf/core/assets/flags';
import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';
import type { Dispatch } from '@swf/core/store';
import countries from '@swf/generated/countries.json';

import {
  TXTCLI_Cancel,
  TXTCLI_Continue,
  TXTWCL_From_your_current_locationX_yo_ELL,
  TXTWCL_It_looks_like_youXre_in_N0
} from './RedirectNotification.messages.json';
import styles from './RedirectNotification.scss';
import PokerStarsCasinoLogo from './assets/pokerstars-casino.svg';

const cookies = new Cookies();

const RedirectNotification: React.FC = () => {
  const geoRedirectTarget = useSelector(select.cms.getGeoRedirectTarget);
  const country = useSelector(select.country.getCountry);
  const countryName = (countries as { value: string; text: string }[]).find(
    ({ value }) => value === country
  )?.text;
  const brand = useSelector(select.cms.getBrandName);

  const allowCancel = useFeature(FeatureFlag.AllowSoftRedirectCancel);
  const { setStyle } = useContext<ModalContextValue>(ModalContext);
  const { push } = useHistory();
  const { modal } = useDispatch<Dispatch>();
  const flag = country && flags[country];

  useEffect(() => {
    setStyle({ className: styles.transparent });
  });

  useEffect(() => {
    if (!countryName) modal.close('/notifications/redirected');
  }, [modal, countryName]);

  return (
    <div className={styles.redirectModal}>
      <div className={styles.flagWrapper}>{flag && <img width={20} src={flag} alt="" />}</div>
      <div className={styles.location}>
        <Translation {...TXTWCL_It_looks_like_youXre_in_N0} values={{ 0: countryName }} />
      </div>
      <div className={styles.access}>
        <Translation {...TXTWCL_From_your_current_locationX_yo_ELL} values={{ 0: brand }} />
      </div>
      <StarsButton
        className={styles.continueButton}
        translation={TXTCLI_Continue}
        onClick={() => {
          if (geoRedirectTarget) {
            window.location.href = `${geoRedirectTarget}`;
          } else {
            push('/');
          }
        }}
      />
      {allowCancel && geoRedirectTarget ? (
        <StarsButton
          className={styles.cancelButton}
          translation={TXTCLI_Cancel}
          variant="secondary"
          onClick={() => {
            cookies.set(CookieNames.SOFT_REDIRECT_CANCELLED, true, { path: '/' });
            window.location.reload();
          }}
        />
      ) : null}
      <PokerStarsCasinoLogo className={styles.pokerstarsIcon} width={130} height={28} />
    </div>
  );
};

export default RedirectNotification;
